import { Skeleton } from '@vtex/shoreline'

interface LoadingValueProps {
  children: React.ReactNode
  width?: string
  height?: string
  isLoading: boolean
  style?: React.CSSProperties
}

export const LoadingValue = ({
  children,
  width = '300px',
  height = '1rem',
  isLoading,
  style
}: LoadingValueProps) => {
  return isLoading ? (
    <Skeleton
      data-testid="skeleton"
      height={height}
      width={width}
      style={style}
    />
  ) : (
    children
  )
}

export default LoadingValue
